module.exports = __webpack_public_path__ + "static/fb-preview-corona.ded532b1.jpg";